import React from 'react';
import  Kannadacca3to52024  from 'views/Kannadacca3to52024';
const BlogNewsroomPage = () => {
return <Kannadacca3to52024/>
};
export default BlogNewsroomPage;